export function createRange(size: number, startAt: number = 0): number[] {
  return Array.apply(null, Array(size)).map((_, i) => i + startAt);
}

export function convertToDoubleDigits(num: number) {
  let value: number | string = num;
  if (value <= 9 && value >= 0) {
    value = `0${num}`;
  }
  return value;
}

export function toFixedWithoutRound(num: number, fixed: number) {
  let decimalDigits = fixed || 0;
  decimalDigits = Math.pow(10, decimalDigits);
  return Math.floor(num * decimalDigits) / decimalDigits;
}

export function isNumber(num: any): boolean {
  return typeof num === 'number' && !isNaN(num);
}

export function convertToFloat(value: string): number {
  return parseFloat(value) || 0;
}